import { render, staticRenderFns } from "./ClientEmails.vue?vue&type=template&id=a30561a4&scoped=true&"
import script from "./ClientEmails.vue?vue&type=script&lang=js&"
export * from "./ClientEmails.vue?vue&type=script&lang=js&"
import style0 from "./ClientEmails.vue?vue&type=style&index=0&id=a30561a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30561a4",
  null
  
)

export default component.exports